// extracted by mini-css-extract-plugin
export default {"root":"FKIIUo","line":"LW9wSl"};